import showdown from 'showdown';

export const Config = {
  Routing: {
    user: '/api/user.json',
    login: '/login',
    quiz: (id) => `/forms/${id}.json`,
    step: (id, step) => `/learning_pathways/${id}/content?step=${step}`,
    pathway: (id) => `/learning_pathways/${id}.json`,
    progress: (pathwayID) => `/learning_pathways/${pathwayID}/progress.json`,
    updateStep: (pathwayID) => `/learning_pathways/${pathwayID}/step.json`,
  },
  State: {
    initial: 'initial',
    loaded: 'loaded',
    failed: 'failed',
  },
  UserState: {
    unknown: 'unknown',
    loggedIn: 'logged-in',
    loggedOut: 'logged-out',
  },
  Step: {
    Format: {
      video: 'video',
      summary: 'summary',
      article: 'article',
      quiz: 'quiz',
    },
    Status: {
      notStarted: 'not_started',
      skipped: 'skipped',
      completed: 'completed',
    }
  },
  I18n: {
    OnThisPage: I18n.t('learning_pathways.navigation.label'),
    Progress: I18n.t('learning_pathways.progress.label'),
    SaveProgress: I18n.t('learning_pathways.progress.save_progress'),
    FooterDefaultLabel: I18n.t('learning_pathways.footer.default_label'),
    Complete: (percent) => I18n.t('learning_pathways.progress.completed', {percent: percent}),
    Action: {
      Skip: I18n.t('learning_pathways.actions.skip'),
      Next: I18n.t('learning_pathways.actions.next'),
      ReadAgain: I18n.t('learning_pathways.actions.read_again'),
      NextSteps: I18n.t('learning_pathways.actions.next_steps'),
      Continue: I18n.t('learning_pathways.actions.continue'),
      SingIn: I18n.t('learning_pathways.actions.sign_in'),
      ReadAll: I18n.t('learning_pathways.actions.read_all'),
    },
    Summary: {
      DefaultWarningMessage: I18n.t('learning_pathways.summary.default_warning_message'),
      Completed: I18n.t('learning_pathways.summary.completed'),
    },
    Modal: {
      Congratulations: 'Congratulations!',
      CongratulationsText: 'You have completed the course.',
      Confirm: 'Done',
    },
    Errors: {
      ConfigNotLoaded: 'This pathway is temporarily unavailable. Please try again later.',
      BrokenStep: 'This step is currently unavailable. Please skip and continue with other steps.',
      SubmissionFailure: 'Something went wrong with your submission. Please try again.',
      ModalTitle: 'Unexpected Error',
      Network: {
        FailedToUpdateStep: 'Unable to update step. Please try again.',
        FailedToLoadQuiz: 'Failed to load quiz. Please refresh the page.',
        FetchProgress: 'Unable to load pathway progress. Please refresh the page.',
        FetchConfig: 'Unable to load pathway configuration. Please try again later.',
        FetchStepContent: 'Failed to load step content. Please try again.',
        FormSubmission: 'Failed to submit form. Please check your connection and try again.'
      }
    }
  }
};

export function IsCurrentStep(step, currentStep) {
  if (!step || !currentStep) {
    return false;
  }
  if (!step.id || !currentStep.id) {
    return false;
  }

  return step.id === currentStep.id;
}

export function isCompleted(stepID, completedIDs) {
  return completedIDs.includes(stepID);
}

export function isQuiz(format) {
  return `${format}`.toLowerCase() === Config.Step.Format.quiz;
}

function doScroll(el) {
  if (!el) {
    console.log(`[Pathway] Unable to find pathway section`);
    return;
  }

  const timeout = 100;

  el.open = true;
  setTimeout(() => {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }, timeout);
}

export function scrollToCurrentStep() {
  doScroll(document.querySelector(`.pathway-step[data-status="${Config.Step.Status.notStarted}"]`));
}

export function scrollToLastStep() {
  const steps = document.querySelectorAll('.pathway-step');
  const lastStep = steps[steps.length - 1];
  doScroll(lastStep);
}

export function markdownToHtml(markdown) {
  let converter = new showdown.Converter();
  return converter.makeHtml(markdown);
}

export function isSummary(format) {
  return `${format}`.toLowerCase() === Config.Step.Format.summary;
}

export function progressMap(progress) {
  let m = new Map();
  for (const item of progress) {
    m.set(item.step_id, item);
  }
  return m;
}

export function formParams(payload) {
  return JSON.stringify({data: payload})
}

export function requestHeaders() {
  return {
    'X-CSRF-Token': getCsrfToken(),
    'Content-Type': 'application/json',
  }
}

export function onTextMarkdownHandler(survey, options) {
  let converter = new showdown.Converter();
  //convert the markdown text to html
  let str = converter.makeHtml(options.text);
  //remove root paragraphs <p></p> if they're wrapping the entire content
  if (str.startsWith('<p>') && str.endsWith('</p>')) {
    str = str.substring(3, str.length - 4);
  }
  //set html
  options.html = str;
}

export function navigateToURL(url) {
  if (!url) {
    return;
  }

  setTimeout(() => {
    window.open(url, '_blank');
  }, 300);
}
